export default __webpack_public_path__ + "static/media/rehack-2.2a7cbb4b.png";